import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-248" data-mp="o5hzekipto28">
      <div className="mx-auto max-w-4xl px-4" data-id="element-249" data-mp="j7oya5w9rk8t">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-250" data-mp="j901a3hw4nyv">Resumen final</h2>
        <p className="mt-3 text-center text-muted" data-id="element-251" data-mp="1gsumcvssfxw2">
          {productName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-ink" data-id="element-252" data-mp="16wrauzc1qmwg">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-253" data-mp="16v6gpatn95z4">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-white p-4 shadow-card" data-id="element-254" data-mp="12umkqakt48ek">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-prevention" data-id="element-255" data-mp="3robckw7l0avv">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-256" data-mp="3nnrhdy6kjhcd" />
              </span>
              <p data-id="element-257" data-mp="3ib3anlcensgd">
                <b className="block text-sm text-ink" data-id="element-258" data-mp="3nbqwlsls1j3q">{feature}</b>
                <span className="text-sm text-muted" data-id="element-259" data-mp="3n9wlt747z7dd">{detail}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}